(function () {
    'use strict';

    angular
        .module('auditMandateEditModule')
        .controller('auditMandateFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$mdToast', 'auditMandateService', 'grcGovernanceProcessService']

    function Controller($rootScope, $scope, $state, $mdToast, auditMandateService, grcGovernanceProcessService) {

        grcGovernanceProcessService.getFiscalYears().then(function (fiscalYears) {
            $scope.fiscalYears = fiscalYears;
            // When in Create Mode

            if (_.isUndefined($scope.boxModel.GovernanceProcessID) && fiscalYears[0]) {

                $scope.boxModel.FiscalYearID = fiscalYears[0].FiscalYeacreateOrUpdaterID;
                $scope.boxModel.ShortName = fiscalYears[0].Name;
            
                $scope.pageIsDirty();
            }
        });

        if ($scope.boxModel.StartDate) $scope.boxModel.StartDate = moment($scope.boxModel.StartDate);
        if ($scope.boxModel.EndDate) $scope.boxModel.EndDate = moment($scope.boxModel.EndDate);
        if ($scope.boxModel.Deadline) $scope.boxModel.Deadline = moment($scope.boxModel.Deadline);


        $scope.pageIsDirty = function () {

            $scope.ctxtCtrl.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };
        $scope.pageIsNotDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Toggle Is Active
        $scope.toggleIsActive = function () {
            $scope.boxModel.IsActive = !$scope.boxModel.IsActive;
            $scope.pageIsDirty();
        };

        // Select Owner
        $scope.selectLeadAuditor = function (person) {
            $scope.boxModel.LeadAuditor = person;
            $scope.boxModel.LeadAuditorID = person.ItemPersonID;
            $scope.pageIsDirty();
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            if (!$scope.canEdit) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        };

        // Show Save Action
        $scope.showSaveAction = function (form) {
            if (!$scope.canEdit) return false;
            if (!$scope.boxModel.GovernanceProcessID) return false;
            if (form.$invalid) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Show Add Action
        $scope.showAddAction = function (form) {
            if ($scope.boxModel.GovernanceProcessID) return false;
            if (form.$invalid) return false;

            return $scope.canEdit;
        };

        // Create Or Update
        $scope.create = function () {
            if ($scope.isLoading) return;

            $scope.isLoading = true;

            auditMandateService
                .createAuditMandate($scope.boxModel)
                .then(function (auditMandate) {

                    if (_.isUndefined($scope.boxModel.GovernanceProcessID)) {
                        $state.go('auditMandateEdit', {
                            AuditMandateID: auditMandate.AuditMandateID,
                            SkipDirtyCheck: true
                        });
                    } else {
                        $mdToast.show(
                            $mdToast
                            .simple()
                            .content('Your changes have been saved!')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                        );
                        $scope.boxModel = auditMandate;

                        $scope.pageIsNotDirty();
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        // Create Or Update
        $scope.update = function () {
            if ($scope.isLoading) return;

            $scope.isLoading = true;

            auditMandateService
                .updateAuditMandate($scope.boxModel)
                .then(function (auditMandate) {
                    $mdToast.show(
                        $mdToast
                        .simple()
                        .content('Your changes have been saved!')
                        .position('top right')
                        .hideDelay($scope.govNotificationDelay)
                        .action('OK')
                        .theme('primary')
                    );
                    $scope.boxModel = auditMandate;

                    $scope.pageIsNotDirty();
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
    }
})();